import ProjectsDatatable from './ProjectsDatatable';
import ProjectsHeader from './ProjectsHeader';

interface ObjectHomeProps {
  filter?: string;
}

const ProjectsHome = ({ filter }: ObjectHomeProps) => {
  // const [filterData, setfilterData] = useState(filter);

  return (
    <>
      <ProjectsHeader title="Projects" />
      <div
        className="slds-grid flex-grow-1 min-height-0 min-width-0"
        style={{ borderTop: '1px solid rgb(224, 229, 238)' }}
      >
        <div
          className="slds-col"
          style={{
            background: '#f3f2f2'
          }}
        >
          <ProjectsDatatable />
        </div>
      </div>
    </>
  );
};

export default ProjectsHome;
